import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedCommissionTable: {
      name: null,
      commissionProfileDetails: [],
    },
    commissionTablesWithSubModels: {},
  }),

  mutations: {
    setSelectedCommissionTable(state, commissionTable) {
      Vue.set(state, "selectedCommissionTable", commissionTable);
    },
    setCommissionTables(state, commissionTables) {
      Vue.set(state, "commissionTables", commissionTables);
    },
    setDefaultCommissionModule(state, commissionTablesWithSubModels) {
      Vue.set(state, "selectedCommissionTable", {
        name: null,
        commissionProfileDetails: [],
      });
      Vue.set(state, "commissionTablesWithSubModels", {});
    },
  },

  actions: {
    //TODO: load, update, create
    createCommissionTable: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/commission-profiles/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadCommissionTables: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/entity").then((response) => {
        context.commit("setCommissionTables", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadCommissionTable: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/entity/" + request.id).then((response) => {
        context.commit("setSelectedCommissionTable", response.data);
        return response.data;
      });
    },

    loadPublishedCommissionTables: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSelectedCommissionTableHistory: (context, commissionTable) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/history/" + commissionTable.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteCommissionTable: (context, commissionTable) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/commission-profiles/entity/" + commissionTable.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          commissionTable.intents = intents;
          commissionTable.intentId = response.data.id;
          return commissionTable;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftCommissionTable: (context, commissionTable) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/commission-profiles/draft/" + commissionTable.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishCommissionTable: (context, commissionTable) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/publish/" + commissionTable.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        //Fixme: intents type CREATE_STATION ise get isteği atılmalı.
        if (commissionTable.intents[0].type === "DELETE_COMMISSION") {
          let commissionTables = context.getters.getSegments;
          commissionTables.splice(commissionTables.indexOf(commissionTable), 1);
          context.commit("setCommissionTables", commissionTables);
        }
        return response.data;
      });
    },

    rejectCommissionTable: (context, commissionTable) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/reject/" + commissionTable.intentId).then((response) => {
        helper.recallOrRejectEntity(commissionTable, "commissionTable");
        return response.data;
      });
    },

    sendToApprovalCommissionTables: (context, commissionTable) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/sendToApproval/" + commissionTable.intentId).then((response) => {
        if (commissionTable.intents[0].type === "CREATE_COMMISSION") {
          commissionTable.intents[0].status = "WAITING_APPROVAL";
        } else if (commissionTable.intents[0].type === "UPDATE_COMMISSION") {
          commissionTable.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallCommissionTable: (context, commissionTable) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/recall/" + commissionTable.intentId).then((response) => {
        helper.recallOrRejectEntity(commissionTable, "commissionTable");
        return response.data;
      });
    },

    cancelCommissionTable: (context, commissionTable) => {
      return axios.get(context.getters.getMcServiceUrl + "/commission-profiles/cancel/" + commissionTable.intentId).then((response) => {
        return response.data;
      });
    },

  },

  getters: {
    getSelectedCommissionTable: (state) => {
      return state.selectedCommissionTable;
    },
    getCommissionTables: (state) => {
      return state.commissionTables;
    },
  },
};
